import * as idcta from '../idcta';

const notificationsAnalytics = require('../analytics');
const request = require('../http');
const config = require('../config');

let data;
const defaultProducts = ['IPLAYER', 'MUSIC'];
const friendlyProductNames = {
    IPLAYER: 'iPlayer',
    MUSIC: 'Music'
};

const subscriptionDomains = ['tv', 'music', 'radio', 'e2etest'];

const readFilter = require('../readFilter');

function checkStatus(response) {
    if (response.status >= 200 && response.status < 400) {
        return response;
    }

    const error = new Error(`HTTP request failed ${response.statusText}`);
    error.response = response;
    throw error;
}

module.exports = {
    friendlyProductNames,

    get() {
        return data;
    },

    filterSubscriptionDomains(i) {
        if (!i.topic) {
            return false;
        }

        const urn = i.topic.split(':');

        if (urn[0] === 'urn' && urn[1] === 'bbc' && urn[2]) {
            return subscriptionDomains.includes(urn[2]);
        }

        return false;
    },

    fetch(refresh = true) {
        if (refresh === false && data) {
            console.log('Fetching preferences from local cache');
            return Promise.resolve(data);
        }

        console.log('Fetching preferences');
        return idcta.refreshToken()
        .catch((err) => {
            notificationsAnalytics.log('error-refresh-token', 'notifications-error');
            console.log('Preferences error');
            throw err;
        })
        .then(() =>
            request(this.fetchCorrectDomainEndpoint(
                config.env.preferencesUrls.getUK,
                config.env.preferencesUrls.get),
                {
                    credentials: 'include'
                }
            )
        )
        .catch((err) => {
            console.log('Preferences error');
            throw err;
        })
        .then((json) => {
            data = json;
            console.log('Returned preferences', data);

            if (data.key) {
                throw new Error(data);
            }

            if (!data.preferences) {
                data.preferences = {
                    readFilter: (typeof readFilter.filter !== 'undefined') ?
                        JSON.stringify(readFilter.getCleanArray()) : null
                };
            }

            if (!data.preferences.productsEnabled) {
                data.preferences.productsEnabled = defaultProducts.map(product => { // eslint-disable-line
                    return { product, enabled: true };
                });
            }

            console.log('Fetched preferences', data);
            if (data.subscriptions) {
                data.subscriptions = data.subscriptions.filter(this.filterSubscriptionDomains);
            }

            return data;
        });
    },

    getHostname() {
        return window.location.hostname;
    },

    fetchCorrectDomainEndpoint(endpointUK, endpointCom) {
        const hostname = this.getHostname();

        return hostname.includes('.com') ? endpointCom : endpointUK;
    },

    set(newData) {
        if (!data) {
            return false;
        }

        const mergedPrefs = Object.assign(data.preferences || {}, newData.preferences);
        data.preferences = mergedPrefs;
        delete data.preferences.lastRead;
        delete data.preferences.currentDateTime;

        console.log('Merged prefs', mergedPrefs);
        console.log('Setting data', data);

        console.log('Preference set idcta object', idcta);

        return idcta.refreshToken()
        .catch((err) => {
            throw err;
        })
        .then(() => fetch(this.fetchCorrectDomainEndpoint(
            config.env.preferencesUrls.postPreferenceUK,
            config.env.preferencesUrls.postPreference),
            {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data.preferences)
            })
        )
        .then(checkStatus)
        .catch((err) => {
            throw err;
        })
        .then(() => {
            delete data.preferences.onboardingFlag;
            this.fetch();
        });
    },

    updateRead(lastReadFlag = false) {
        return this.set({
            preferences: {
                readFilter: (typeof readFilter.filter !== 'undefined') ?
                    JSON.stringify(readFilter.getCleanArray()) : null,
                lastReadFlag
            }
        });
    },

    sendClick(notification) {
        const requestBody = {
            preference: data.preferences,
            notificationId: notification.id,
            topicUrn: notification.topic[0]
        };

        return idcta.refreshToken()
        .catch((err) => {
            throw err;
        })
        .then(() => fetch(this.fetchCorrectDomainEndpoint(
            config.env.preferencesUrls.postClickUK,
            config.env.preferencesUrls.postClick),
            {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
        )
        .then(checkStatus)
        .catch((err) => {
            throw err;
        });
    },

    countActiveSubscriptions() {
        let counter = 0;

        if (data.subscriptions) {
            data.subscriptions.forEach((item) => {
                if (item.enabled) {
                    counter++;
                }
            });
        }

        return counter;
    },

    updateUserOnBoarding(cb) {
        let newData = data.preferences || {};

        if (!newData) {
            newData = {
                lastReadFlag: true,
                productsEnabled: [],
                readFilter: readFilter.getCleanArray()
            };

            defaultProducts.forEach((product) => {
                newData.productsEnabled.push({ product, enabled: true });
            });
        }

        newData.hasOnboarded = true;
        newData.onboardingFlag = true;
        newData.lastReadFlag = true;
        this.set(data)
        .then(cb)
        .catch((err) => {
            cb(err);
            throw err;
        });
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/models/UserPreferences.js
 **/